import { render, staticRenderFns } from "./sub-menu.vue?vue&type=template&id=516b3cb6&functional=true"
import script from "./sub-menu.vue?vue&type=script&lang=js"
export * from "./sub-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports